// IMPORTANT Autogenerated file
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OrderStatusDto } from '@ellf/common-dto';
import { ApiClientConfig } from '../api-client-config';
import { BaseCRUDApiClient } from './baseCRUD.api-client';

@Injectable()
export class OrderStatusApiClient extends BaseCRUDApiClient<OrderStatusDto> {
  baseUrl = this.config.apiEndpoint + '/order-status';

  constructor(http: HttpClient, config: ApiClientConfig) {
    super(http, config);
  }
}
